// Copyright (c) StrangeBee 2023

import { classList, useLocalMessage } from '@Helpers/';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { THForm } from '@Molecules/THForm/THForm';
import { FormInstance } from 'antd/lib/form';
import { ReactElement, ReactNode } from 'react';
import { FormListFieldData } from 'antd/lib/form/FormList';

import './CreateListItem.scss';

interface CreateListItemProps<T> {
    field: FormListFieldData;
    form: FormInstance;
    editDrawer?: (onFinish: (item: T) => void, triggerElem: ReactElement) => ReactElement;
    title: ReactNode;
    remove: (name: number) => void;
    className?: string;
    removeLabel?: string;
}

export const CreateListItem = <T,>({
    field,
    form,
    editDrawer,
    title,
    remove,
    className,
    removeLabel,
}: CreateListItemProps<T>): ReactElement => {
    const i = useLocalMessage();

    const { name, key } = field;

    const items = form.getFieldValue(name) as any[];

    const editItem = (newItem: any): void => {
        form.setFieldsValue({
            [name]: items.map((item, index) => (index === name ? newItem : item)),
        });
    };

    return (
        <THForm.Item key={key} noStyle>
            <div className={classList('list-item', className)}>
                <div className="list-item__title">{title}</div>

                <div className="list-item__actions">
                    {editDrawer?.(editItem, <THButton type="link">{i('general.edit')}</THButton>)}

                    <THButton type="link" onClick={(): void => remove(name)} danger>
                        {removeLabel ?? i('general.delete')}
                    </THButton>
                </div>
            </div>
        </THForm.Item>
    );
};
